import { BoardMembershipRoles } from '../constants/Enums';

export const isAdminBoardMember = (currentUser, boardMembership) =>
  currentUser?.isAdmin === true && !!boardMembership;

export const isAdminEditorBoardMember = (currentUser, boardMembership) =>
  currentUser?.isAdmin === true && boardMembership?.role === BoardMembershipRoles.EDITOR;

export const canManageBoardMemberships = (currentUser, boardMembership, isProjectManager) =>
  !!currentUser?.isSAdmin ||
  !!isProjectManager ||
  isAdminEditorBoardMember(currentUser, boardMembership);

export default function canEditBoardContent(currentUser, boardMembership) {
  if (currentUser?.isSAdmin === true) {
    return true;
  }

  if (isAdminBoardMember(currentUser, boardMembership)) {
    return true;
  }

  return !!boardMembership && boardMembership.role === BoardMembershipRoles.EDITOR;
}
